export default __webpack_public_path__ + "static/media/diversio-logo-with-symbol-for-light-bg.4423a8ea.svg";